import { chartColours } from "../Charts/chart-util"
import {
  Cell,
  PieChart,
  Pie,
  Legend,
  ResponsiveContainer,
  Tooltip,
} from "recharts"

function legendFormatter(value, payload, formatter) {
  const payloadValue = payload.value
  const formattedValue = formatter(payloadValue)
  return `${value}: ${formattedValue} (${payload.percent_value}%)`
}

export default function PieView({ data, tooltipContent, formatter }) {
  return (
    <ResponsiveContainer>
      <PieChart>
        <Pie
          data={data}
          nameKey="name"
          dataKey="value"
          isAnimationActive={false}
          innerRadius="40%"
        >
          {data.map((el, index) => (
            <Cell key={`cell-${index}`} fill={chartColours[index]} />
          ))}
        </Pie>
        <Tooltip content={tooltipContent} />
        <Legend
          formatter={(value, entry) =>
            legendFormatter(value, entry.payload, formatter)
          }
          layout="horizontal"
          align="bottom"
          verticalAlign="bottom"
          wrapperStyle={{
            fontSize: "12px",
            textOverflow: "ellipsis",
            overflow: "hidden",
          }}
        />
      </PieChart>
    </ResponsiveContainer>
  )
}
